module.exports = __webpack_public_path__ + "img/analytics.fadcd59a.svg";